import React, { useCallback, useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import RankedQueryCard from "../../charts/RankedQueryCard";
import { unsubscribeReasonsQuery } from "../offerAnalytics.queries";
import { buildUnsubscribeReasons } from "../offerAnalytics.utils";

import type { JSX } from "react";

import type { GetUnsubscribeReasonsResponse } from "@/src/api/StatsAPI.types";

import type { ChartSeries } from "../../charts/charts.types";
import type {
  CountSeriesKey,
  OfferAnalyticsFilterProps,
} from "../offerAnalytics.types";

function UnsubscribeReasonsCard({
  filters,
}: OfferAnalyticsFilterProps): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t, i18n } = useTranslation("editor-analytics");
  const lang = i18n.language;

  const seriesList = useMemo(
    (): ChartSeries<CountSeriesKey>[] => [
      {
        key: "count",
        label: t("offerAnalytics.series.reasons"),
        color: "var(--chart-1)",
      },
    ],
    [t],
  );
  const buildRankedList = useCallback(
    (response: GetUnsubscribeReasonsResponse | undefined) =>
      buildUnsubscribeReasons(response, lang, (reason) =>
        t(`unsubscribe_reasons.${reason}`),
      ),
    [lang, t],
  );

  return (
    <RankedQueryCard
      buildRankedList={buildRankedList}
      query={unsubscribeReasonsQuery(projectSlug, filters, lang)}
      seriesList={seriesList}
      title={t("offerAnalytics.charts.unsubscribeReasons")}
    />
  );
}

export default UnsubscribeReasonsCard;
